import { clientLogging } from '@bfa/nextjs-common/services';

import { GQLProgram } from '../gql.generated';

export const getGqlProgram = (
  programName: string | undefined | null
): GQLProgram | null => {
  if (!programName) {
    return null;
  }

  const key = programName.toUpperCase();
  const program = GQLProgram[key as GQLProgram] || null;

  if (program === GQLProgram.CREATOR_SEED) {
    clientLogging.logInfo({
      content: 'Unexpected usage of CREATOR_SEED program',
    });
    return null;
  }

  return program;
};
